import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import jmmStyles from './style.module.scss';
import cn from 'classnames';

var CustomSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomSelect, _React$Component);

  function CustomSelect() {
    _classCallCheck(this, CustomSelect);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomSelect).apply(this, arguments));
  }

  _createClass(CustomSelect, [{
    key: "render",
    value: function render() {
      return React.createElement(FormControl, {
        className: cn(jmmStyles.formControl, _defineProperty({}, this.props.className, this.props.className))
      }, React.createElement(Select, {
        value: this.props.value,
        onChange: this.props.onChange,
        inputProps: {
          name: this.props.name,
          id: this.props.name
        },
        className: jmmStyles.customSelectbox,
        classes: {
          selectMenu: this.props.smallMenu ? jmmStyles.smallSelectMenu : jmmStyles.selectMenu
        }
      }, this.props.children));
    }
  }]);

  return CustomSelect;
}(React.Component);

export default withStyles(jmmStyles)(CustomSelect);